import { useState, useEffect } from 'react';

import { DOC_VISIBILITY, DocVisibility } from '@/lib/api';

/** Returns the visibility validation error for content that mentions other users. */
export const useVisibilityError = (
  text: string,
  visibility: DocVisibility,
  inheritedVisibility?: DocVisibility
) => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const hasMentions = /@\w+/.test(text);

    if (hasMentions) {
      if (inheritedVisibility === DOC_VISIBILITY.Private) {
        setError("This thread is private, can't tag friends");
      } else if (visibility === DOC_VISIBILITY.Private) {
        setError("Can't tag friends in private posts");
      } else {
        setError(null);
      }
    } else {
      setError(null);
    }
  }, [text, visibility, inheritedVisibility]);

  return error;
};
